import { getPageVisibilityState } from '../../hidden-timing';
export default function getPageVisibilityUpToTTAI(interaction) {
  var start = interaction.start,
    end = interaction.end;
  return getPageVisibilityState(start, end);
}